import React from 'react';

const RecordingTransferModal = ({ 
  isOpen, 
  setRecordingTransferModel, 
  setAdminListModel, 
  setIsRecordingModal 
}) => {
  if (!isOpen) return null;

  return (
    <div className="dialog-overlay">
      <div className="dialog">
        <h2 className='req-record'>Recording Transfer</h2>
        <p className='record-call'>Do you want to transfer the recording to Co-Host?</p>
        <div className='recrd-btn-align'>
          <button onClick={() => {
            setRecordingTransferModel(false);
            setAdminListModel(true);
          }} className='allw-btn'>
            Yes
          </button>
          <button onClick={() => {
            setRecordingTransferModel(false);
            setIsRecordingModal(true);
          }} className='rej-btn'>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecordingTransferModal;
